import React from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { getPreloadData } from './actions/preload';
import AppLoading from './components/common/AppLoading';
import { I18nContextProvider } from './providers/i18n';
import Routes from './routes';

const App = props => {
  const { loading } = props;
  return (
    <AppLoading loading={loading}>
      <I18nContextProvider>
        <Router>
          <Routes />
        </Router>
      </I18nContextProvider>
    </AppLoading>
  );
};

const mapStateToProps = ({ appUi }) => ({
  loading: appUi.globalLoading
});

const mapDispatchToProps = dispatch => ({
  preload: () => dispatch(getPreloadData())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
